import { ObjectAggregateT, useObjectAggregate } from '../api/object'
import { CurrencyFormatter } from '../components/currency-formatter'
import { DueFormatter } from '../components/due-formatter'
import { Paper } from '../components/paper'

const EMPTY_AGGREGATE: ObjectAggregateT = { total: 0, rows: 0, key: '' }
export function WidgetSum({ id }: { id: string }) {
	const { data: [{ total: revenue = 0 }] = [{}] } = useObjectAggregate('payment', {
		reservation_id: id,
	})
	const { data: expenses = [] } = useObjectAggregate('expense', {
		reservation_id: id,
		group: 'due',
	})
	const overdue = expenses.find(e => e.key === 'overdue') ?? EMPTY_AGGREGATE
	const future = expenses.find(e => e.key === 'future') ?? EMPTY_AGGREGATE
	const totalExpense = overdue.total + future.total

	if (revenue === 0 && totalExpense === 0) {
		return null
	}

	return (
		<Paper>
			<div className="flex flex-col justify-between gap-4 px-5 py-4 sm:px-6 sm:py-5">
				<h3 className="text-md font-bold">Účetnictví</h3>
			</div>
			<table className="w-full">
				<tbody>
					<tr>
						<th>Souhrn</th>
						<td width="65%">
							<div className="flex items-center justify-between gap-4">
								<CurrencyFormatter value={totalExpense - revenue} />
							</div>
						</td>
					</tr>
					<tr>
						<th>Dluh</th>
						<td width="65%">
							<div className="flex items-center justify-between gap-4">
								<DueFormatter value={overdue.total - revenue} />
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</Paper>
	)
}
